import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/jimmyz_wd/" className="home__social-icon" target="_blank"><i className="uil uil-instagram"></i></a>
        <a href="https://www.linkedin.com/in/muhammed-ahmed-anwar-8a5433213/" className="home__social-icon" target="_blank"><i class="uil uil-linkedin"></i></a>
        <a href="https://github.com/muhammedahmedanwar" className="home__social-icon" target="_blank"><i class="uil uil-github"></i></a>

    </div>
  )
}

export default Social
